<template>
  <div class="ranking_activity">
      <div class="top_blank"></div>
      <div class="top">
          <span class="back" @click="goBack"><i></i></span>
          <div class="title">
            <span>{{hh}}</span>:
            <span>{{mm}}</span>:
            <span>{{ss}}</span>
            <div>后本期冲榜结束</div>
          </div>
          <span class="show_popup" @click="showPopup">规则</span>
      </div>

      <div class="header">
        <div class="header_step">
          <div class="header_step_item"><span>1</span>试玩小游戏></div>
          <div class="header_step_item"><span>2</span>领取成绩></div>
          <div class="header_step_item"><span>3</span>进入排行></div>
          <div class="header_step_item"><span>4</span>次日领奖</div>
        </div>
        <div class="game_info">
            <div class="game_icon"><img :src="gameIcon"/></div>
            <div class="game_title">{{gameName}}</div>
            <div class="game_money">-&nbsp;排行榜每15分钟更新一次&nbsp;-</div>
        </div>
        <div class="kefu" @click="goKefu">联系客服</div>
      </div>
      <div class="reward_box">
        <div class="ranking_title">
            <i class="t_tl"></i>擂台赛奖励<i class="t_tr"></i>
        </div>

        <div class="ranking_reward">
          <div v-for="(item, key) in ruleShow" :key=key  :class="getRuleClass(item.rank_index)">
            <div class="money_icon">
              <i></i>
              <div>{{item.reward_money}}</div>
            </div>
            <span>{{item.rank}}</span>
          </div>

        </div>

        <div class="ranking_tips">*冲榜攻略：使用翻倍卡、点击复活、两倍领取成绩更容易上榜</div>

      </div>

      <div class="main_box">
        <div class="tab">
            <span v-for="(item, key) in dateTab" :key="key" :class="getDateClass(key)" @click="getRankingList(key, item.today)">{{item.txt}}<i></i></span>
        </div>

        <div class="rangking_list">

          <div class="second" v-if="secondRanking.nickname">
              <span class="avatar"><img :src="abg2" /><i><img :src="secondRanking.avatar" /></i></span>
              <span class="name">{{secondRanking.nickname}}<font v-if="getListClass(secondRanking.style).show == 1" color="#FF7F4B">(我)</font></span>
              <span class="score">{{secondRanking.integral_show}}</span>
         </div>
         
         <div class="first" v-if="firstRanking.nickname">
            <span class="avatar"><img :src="abg1" /><i><img :src="firstRanking.avatar" /></i></span>
            <span class="name">{{firstRanking.nickname}}<font v-if="getListClass(firstRanking.style).show == 1" color="#FF7F4B">(我)</font></span>
            <span class="score">{{firstRanking.integral_show}}</span>
         </div>

         <div class="third" v-if="thirdRanking.nickname">
            <span class="avatar"><img :src="abg3" /><i><img :src="thirdRanking.avatar" /></i></span>
            <span class="name">{{thirdRanking.nickname}}<font v-if="getListClass(thirdRanking.style).show == 1" color="#FF7F4B">(我)</font></span>
            <span class="score">{{thirdRanking.integral_show}}</span>
        </div>

        <div class="normal" v-for="(item, key) in list" :key="key" :class="getListClass(item.style).class">
            <span class="sort">{{item.index}}</span>
            <span class="avatar"><img :src="item.avatar" /></span>
            <span class="name">{{item.nickname}} <font v-if="getListClass(item.style).show == 1" color="#FF7F4B">(我)</font></span>
            <div class="score">{{item.integral_show}}</div>
        </div>

       </div>

      </div>


      <div class="start_btn">
          <a href="javascript:;" @click="toGame">开始游戏&nbsp;&nbsp;冲榜挑战</a>
      </div>

      <div class="popup_bg" :class="{show: isPopupShow}" v-if="isPopupShow" @click="close">
          <div class="popup_box">
            <div class="content">
              <div class="title">冲榜规则</div>
              <div class="intro" v-html="describe"></div>
              <div class="i_konw" @click="close()">我知道了</div>
            </div>

          </div>
        </div>

      <loading :isLoad="isLoad"></loading>
  </div>
</template>

<style>
  body {
    background: #F5F7FA;
    font-family: PingFangSC-Medium;
  }
</style>

<style scoped>
    .top_blank {
      width: 100%;
      height: 0.3rem;
      background-color: #fff;
    }
    .top {
    height: 0.44rem;
    background-color:#fff;
    font-size: 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.16rem;
  }
  .top .title {
    width: calc(100% - 0.8rem);
    line-height: 0.44rem;
    text-align: center;
    font-size: 0.16rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .top .title span {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFF0EB;
    width: 0.3rem;
    height: 0.22rem;
    color:#FF7F4B;
    border-radius: 0.04rem;
    margin: 0 0.03rem;
  }
  .top .title div{
    margin-left: 0.05rem;
  }

  .top .back {
    width: 0.4rem;
    height: 0.44rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .top .back i {
    width: 0.1rem;
    height: 0.1rem;
    border-left: 2px solid #333;
    border-bottom: 2px solid #333;
    transform: rotate(45deg);
  }
  .top .show_popup {
    width: 0.4rem;
    line-height: 0.44rem;
    text-align: right;
    color:#FF7F4B
  }

  .header {
    position: relative;
    display: block;
    width: 100%;
    height: 3rem;
    background: url('~@/assets/images/mini_game/header_bg.png') no-repeat;
    background-size: 3.75rem 3rem;
    overflow: hidden;
  }
  .header_step {
    position: absolute;
    top: 0;
    left: 0.08rem;
    width: 3.39rem;
    height: 0.34rem;
    background-image: linear-gradient(to right, #FF7601 , #FF4500);
    border-radius: 0 0 0.08rem 0.08rem;
    padding: 0 0.1rem;
    display: flex;
    justify-content: space-around;
    font-size: 0.14rem;
    color: #fff;
    align-items: center;
  }

  .header_step .header_step_item{
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .header_step .header_step_item span{
    width: 0.14rem;
    height: 0.14rem;
    border-radius: 0.14rem;
    background-color: #fff;
    color:#FF7601;
    font-size: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.02rem 0 0;
  }
  .game_info {
    margin-top: 0.5rem;
    width: 100%;
  }
  .game_info div {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  .game_icon img {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.06rem;
  }
  .game_info .game_title {
    font-size: 0.24rem;
    color: #fff;
    margin-top: 0.08rem;
    height: 0.33rem;
  }
  .game_info .game_money {
    font-size: 0.12rem;
    color: #fff;
    margin-top: 0.06rem;
    height: 0.17rem;
  }

  .kefu {
    margin: 0.16rem auto 0.16rem auto;
    width: 0.84rem;
    height: 0.3rem;
    line-height: 0.3rem;
    border-radius: 0.15rem;
    border: 0.01rem solid #4A90E2;
    color: #4A90E2;
    font-size: 0.14rem;
    text-align: center;
  }

  .reward_box{
    position: relative;
    display: block;
    width: 3.39rem;
    min-height: 3.11rem;
    padding: 0 0.1rem;
    background: #FFF;
    overflow: hidden;
    border-radius: 0.08rem;
    margin: -0.72rem auto 0.09rem auto;
  }

  .ranking_title{
    display: flex;
    justify-content: center;
    height: 0.25rem;
    align-items: center;
    font-size: 0.18rem;
    color: #333;
    margin: 0.2rem auto;
  }

  .ranking_title i {
    width: 0.46rem;
    height: 0.02rem;
    overflow: hidden;
  }

  .ranking_title i.t_tl {
    margin-right: 0.1rem;
    background: url('~@/assets/images/mini_game/ttl.png') no-repeat;
    background-size: 0.46rem 0.02rem;
  }
  .ranking_title i.t_tr {
    margin-left: 0.1rem;
    background: url('~@/assets/images/mini_game/ttr.png') no-repeat;
    background-size: 0.46rem 0.02rem;
  }
  .ranking_reward {
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
  }
  .ranking_reward div{
    position: relative;
  }
  .ranking_reward .m1{
    width: 1.1rem;
    height: 1rem;
    background: url('~@/assets/images/mini_game/no1.png') no-repeat;
    background-size: 1.1rem 1rem;
    margin: 0 0.14rem;
    margin-bottom: 0.16rem;
  }
  .ranking_reward .m2{
    width: 1rem;
    height: 0.9rem;
    background: url('~@/assets/images/mini_game/no2.png') no-repeat;
    background-size: 1rem 0.9rem;
    margin-bottom: 0.16rem;
  }
  .ranking_reward .m3{
    width: 1rem;
    height: 0.9rem;
    background: url('~@/assets/images/mini_game/no3.png') no-repeat;
    background-size: 1rem 0.9rem;
    margin-bottom: 0.16rem;
  }
  .ranking_reward .m4 {
    margin: 0 0.07rem;
  }
  .ranking_reward .m4{
    width: 0.82rem;
    height: 0.75rem;
    background: url('~@/assets/images/mini_game/non.png') no-repeat;
    background-size: 0.82rem 0.75rem;
  }

  .ranking_reward span {
    position: absolute;
    bottom: 0.07rem;
    width: 100%;
    text-align: center;
    font-size: 0.16rem;
    color: #fff;
  }
  .ranking_reward .m1 span {
    bottom: 0.08rem;
    font-size: 0.16rem;
  }
  .ranking_reward .m4 span{
    bottom: 0.07rem;
    font-size: 0.13rem;
  }
  .ranking_reward .money_icon {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ranking_reward .m1 .money_icon {
    margin-top: 0.21rem;
  }
  .ranking_reward .m2 .money_icon, .ranking_reward .m3 .money_icon{

    margin-top: 0.19rem;
  }
  .ranking_reward .m4 .money_icon {
    margin-top: 0.15rem;
  }
  .ranking_reward .money_icon i {
    display: flex;
    margin-right: 0.02rem;
    width: 0.14rem;
    height: 0.14rem;
    background: url('~@/assets/images/money_icon.png') no-repeat;
    background-size: 0.14rem 0.14rem;
  }
  .ranking_reward .m4 .money_icon i {
    display: flex;
    width: 0.12rem;
    height: 0.12rem;
    background: url('~@/assets/images/money_icon.png') no-repeat;
    background-size: 0.12rem 0.12rem;
  }
  .ranking_reward .money_icon div {
    color: #c65a00;
    font-weight: 800;
  }
  .ranking_reward .m1 .money_icon div {
    font-size: 0.18rem;
  }
  .ranking_reward .m2 .money_icon div, .ranking_reward .m3 .money_icon div {
    font-size: 0.16rem;
  }
  .ranking_reward .m4 .money_icon div {
    font-size: 0.16rem;
  }

  .ranking_tips {
    font-size: 0.12rem;
    color:#333;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    width: 100%;
  }
  .main_box {
    position: relative;
    display: block;
    width: 3.59rem;
    min-height: 4.36rem;
    background: #FFF;
    overflow: hidden;
    border-radius: 0.08rem 0.08rem 0 0;
    margin: 0 auto 0.59rem auto;
  }

  .main_box .tab {
    width: 100%;
    overflow: hidden;
    display: flex;
    border-left: 0.01rem solid #fff;
    border-bottom: 0.01rem solid #F2F2F2 ;
  }
  .main_box .tab span {
    display: flex;
    width: 1.19rem;
    height: 0.54rem;
    justify-content: center;
    align-items: center;
    font-size: 0.16rem;
    color:#333;
    position: relative;
    cursor: pointer;
  }
  .main_box .show {
    color: #FF7F4B !important;
    font-weight: 600;
  }

  .main_box .show i {
    position:absolute;
    display: block;
    width: 0.18rem;
    height: 0.04rem;
    background-color: #FF7F4B;
    border-radius: 0.02rem;
    bottom:0;
    left: 0.5rem;
  }
  .rangking_list {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .rangking_list .first, .rangking_list .second, .rangking_list .third{
    display: flex;
    border-bottom: 0.01rem solid #F2F2F2;
    overflow: hidden;
    padding: 0.18rem 0 0.2rem 0;
    justify-content: center;
  }
  .rangking_list .avatar  {
    height: 1.08rem;
    margin-bottom: 0.05rem;
    position: relative;
  }

  .rangking_list .name, .rangking_list .score{
    height: 0.22rem;
  }

  .rangking_list .first, .rangking_list .second, .rangking_list .third {
    flex-wrap: wrap;
    width: 1.19rem;
    height: 1.58rem;
    font-size: 0.14rem;
    color:#333;
  }

  .rangking_list .first span, .rangking_list .second span, .rangking_list .third span {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .rangking_list .first .name, .rangking_list .second .name, .rangking_list .third .name {
    display: block;
    width: 1rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    text-align: center;
  }

  .rangking_list .second .avatar img, .rangking_list .third .avatar img{
    width: 0.78rem;
    height: 0.9rem;
    z-index: 1;
  }

  .rangking_list .second .avatar i, .rangking_list .third .avatar i{
    position: absolute;
    top: 0.32rem;
    z-index: 0;
  }
  .rangking_list .second .avatar i img, .rangking_list .third .avatar i img{
    width: 0.54rem;
    height: 0.54rem;
    border-radius: 0.28rem;
  }
  .rangking_list .first img{
    width: 0.95rem;
    height: 1.08rem;
    z-index: 1;
  }
  .rangking_list .first .avatar i{
    position: absolute;
    top: 0.24rem;
    z-index: 0;
  }
  .rangking_list .first .avatar i img{
    width: 0.74rem;
    height: 0.74rem;
    border-radius: 0.38rem;
  }
  .rangking_list .score{
    color:#FF7F4B !important;
  }

  .rangking_list .normal{
    display: flex;
    border-bottom: 0.01rem solid #F2F2F2;
    overflow: hidden;
    width: calc(100% - 0.32rem);
    height: 0.62rem;
    padding: 0 0.16rem;
    justify-content: flex-start;
    align-items: center;
  }
  .rangking_list .normal .avatar, .rangking_list .normal img {
    width: 0.34rem;
    height: 0.34rem;
    margin: 0;
    border-radius: 0.17rem;
  }
  .rangking_list .normal .sort {
    font-size: 0.18rem;
    color:#333;
    margin-right: 0.12rem;
  }
  .rangking_list .normal .name {
    font-size: 0.14rem;
    color:#333;
    margin-left: 0.12rem;
    width: calc(100% - 1.8rem);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .rangking_list .normal .score {
    font-size: 0.14rem;
    color:#333 !important;
    position: absolute;
    right: 0.16rem;
  }
  .rangking_list .my .sort, .rangking_list .my .score {
    color:#FF7F4B !important;
  }


  .start_btn {
    position: fixed;
    bottom: 0;
    display: block;
    padding: 0.06rem 0.16rem;
    background-color: #fff;
    z-index: 2;
  }
  .start_btn a {
    text-decoration: none;
    color: #fff;
    background-image: linear-gradient(to right, #FF7601 , #FF4500);
    font-size: 0.18rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: block;
    text-align: center;
    height: 0.54rem;
    line-height: 0.54rem;
    border-radius: 0.08rem;
    width: 3.43rem;
  }

  .popup_bg {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 3.75rem;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    z-index: 99;
    top: 0;
  }
  .popup_bg.show {
    display: flex;
  }
  .popup_bg .popup_box {
    display: block;
    width: 3.11rem;
    background-color: #FFF;
    border-radius: 0.08rem;
    overflow: hidden;
    padding: 0.16rem;
    max-height: calc(100vh - 1.8rem);
    overflow-x: hidden;
    overflow-y: auto;
    
  }
  .popup_bg .popup_box .title {

    font-size: 0.24rem;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .popup_bg .popup_box .content{
    margin: 0 auto;
    background-color: #FFF7F2;
    border-radius: 0.06rem;
    padding: 0.16rem;
  }

  .popup_bg .popup_box .content .intro{
    margin: 0 auto;
    margin-top: 0.16rem;
    padding: 0 0.16rem;
    font-size: 0.14rem;
  }

  .popup_bg .popup_box .i_konw {
    display: block;
    width: 1.7rem;
    height: 0.42rem;
    background-color: #FF7F4B;
    border-radius: 0.08rem;
    font-size: 0.18rem;
    text-align: center;
    line-height: 0.42rem;
    color: #FFF;
    margin: 0 auto;
    margin-top: 0.18rem;
  }

</style>

<script>
import Loading from '@/components/Loading'
import abg1 from '@/assets/images/mini_game/abg1.png'
import abg2 from '@/assets/images/mini_game/abg2.png'
import abg3 from '@/assets/images/mini_game/abg3.png'
import default_icon from '@/assets/images/mini_game/d.png'
import davatar from '@/assets/images/mini_game/davatar.png'

export default {
  created() {
    document.title = "冲榜挑战";
    this.userid = this.$route.query.userid
    this.activityId = this.$route.query.activity_id

    if (!this.userid) {
      this.userid = this.getCookie('userid')
    }
    if (!this.activityId) {
      this.activityId = this.getCookie('activity_id')
    }

    this.getActivityInfo()
  },
  components: {
    Loading
  },
  data() {
    return {
      abg1: abg1,
      abg2: abg2,
      abg3: abg3,
      davatar: davatar,
      userid: '',
      activityId: '',
      gameName: '',
      gameIcon: default_icon,
      gameId: '',
      gameUrl: '',
      gameType: 1,
      describe: '',
      ruleShow: [],
      dateTab: [],
      list:[],
      isPopupShow: false,
      isLoad: false,
      active: 0,
      firstRanking: {},
      secondRanking: {},
      thirdRanking: {},
      hh: '00',
      mm: '00',
      ss: '00',
      endTime: 0,
      kefu: ''
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    getRuleClass (index) {
      // 获取规则的样式
      if (index > 4) {
        index = 4
      }
      return 'm' + index
    },
    getDateClass (key) {
      // tab样式
      if(this.active == key) {
        return 'show'
      } else {
        return ''
      }
    },
    getListClass (style) {
      let r = {}
      if (style == 1) {
          r.class= 'my'
          r.show = 1
      }
      return r;
    },
    getRankingList (key, today) {
      // 获取排行榜数据
      this.active = key
      this.getActivityInfo(today)
    },
    getActivityInfo: function (today) {
      let params = {
        userid: this.userid,
        activity_id: this.activityId,
        today: today
      }

      this.isLoad = true
      this.$http.get('/api/user_web/mini_game_activity_index', {params: params}).then((res) => {
        this.handleReponse(res)
      })
    },
    refreshTask: function () {
      this.getActivityInfo();
    },
    handleReponse: function (response) {
      let data = response.data
      this.gameName = data.title // 游戏名称
      this.gameIcon = data.icon // 游戏图标
      this.dateTab = data.date_tab // 战绩日期标签
      this.gameId = data.game_id
      this.gameUrl = data.game_url
      this.gameType = data.game_type
      this.describe = data.describe
      this.endTime  = data.end_time
      this.kefu = data.kefu_service.service_id

      this.isLoad = false

      this.ruleShow = []  // 规则列表
      let ruleShow = data.rule_show
      let tempRule = []
      ruleShow.forEach(item =>{
        if(item.rank_index != 2){
          this.ruleShow.push(item)
        } else {
          tempRule = item
        }
      })
      this.ruleShow.unshift(tempRule)

      this.list = [] // 战绩排行列表
      this.firstRanking = {}
      this.secondRanking = {}
      this.thirdRanking = {}

      let dataList = data.list
      let tempList = []

      if (dataList) {
        dataList.forEach(item =>{
            // 兼容没有头像的问题
            if(item.avatar == ''){
              item.avatar = this.davatar
            }

            if(item.index == 1){
              this.firstRanking = item
            } else if(item.index == 2) {
              this.secondRanking = item
            } else if (item.index == 3) {
              this.thirdRanking = item
            } else if(item.index > 3 && item.style == 1){
              tempList = item
            } else {
              this.list.push(item)
            }
        })

        // 我的排行放最上面
        if (tempList.nickname) {
          this.list.unshift(tempList);
        }
      }

      let popupClose = localStorage.getItem('ranking_activity_popup_close' + '_' + this.userid + '_' +  this.activityId)
      if (!popupClose || popupClose != 1) {
        this.isPopupShow = true
      } 

    },
    jumpUrl: function(url) {
      window.location.href = url
    },
    goBack: function () {
      window.injectedObject.setJsContent('closeWebview', '')
    },
    goKefu () {
      window.injectedObject.setJsContent('qqservice', this.kefu)
    },
    showPopup () {
      // 开启弹窗
      this.isPopupShow = true
    },
    toGame: function () {
      // 开始游戏跳转
      let data = {
        gameMode: this.gameType,
        gameId: this.gameId,
        url: this.gameUrl,
        activityId: this.activityId
      }
      window.injectedObject.setJsContent('start_nanfeng_game', JSON.stringify(data))
    },
    close: function () {
      // 关闭弹窗
      this.isPopupShow = false
      localStorage.setItem('ranking_activity_popup_close' + '_' + this.userid + '_' +  this.activityId , 1)
    }
  },
  mounted() {
      // 倒计时
      setInterval( ()=> {
          let aaa = parseInt(this.endTime);
          let bbb = parseInt(new Date().getTime()/1000);
          let rightTime = aaa - bbb;
          if (rightTime > 0) {
            // let dd = Math.floor(rightTime / 60 / 60 / 24);
            let hh = Math.floor((rightTime / 60 / 60) % 24);
            let mm = Math.floor((rightTime / 60) % 60);
            let ss = Math.floor(rightTime % 60);
            
            if (hh < 10) {
              hh = '0' + hh
            }
            if (mm < 10) {
              mm = '0' + mm
            }
            if (ss < 10) {
              ss = '0' + ss
            }
            this.hh = hh
            this.mm = mm
            this.ss = ss
          }
      }, 1000);
    }
}
</script>